var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFi2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#BCE6FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.1663 41.3335V36.3335L60.1663 31.3335L61.8329 34.6668L65.1663 36.3335L60.1663 41.3335H55.1663ZM55.1663 41.3335L48.4996 48.0001M65.1663 48.0002C65.1663 57.2049 57.7044 64.6668 48.4997 64.6668C39.2949 64.6668 31.833 57.2049 31.833 48.0002C31.833 38.7954 39.2949 31.3335 48.4997 31.3335M56.833 48.0002C56.833 52.6025 53.102 56.3335 48.4997 56.3335C43.8973 56.3335 40.1663 52.6025 40.1663 48.0002C40.1663 43.3978 43.8973 39.6668 48.4997 39.6668",
    stroke: "#09A2F6",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 80,
    height: 80,
    rx: 40,
    stroke: "#EEF9FF",
    strokeWidth: 14.2857
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFi2);
export default __webpack_public_path__ + "static/media/fi2.fdabc4aaa37a012dd825df7eea30bf71.svg";
export { ForwardRef as ReactComponent };